// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconAnnotationsSplineContour_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.68162 11.8715L1.70591 11.8297L3.44269 12.8324C3.39323 12.9107 3.34487 12.9907 3.29774 13.0723C2.27055 14.8514 2.21331 16.7414 3.1699 17.2937C4.12648 17.846 5.73465 16.8514 6.76184 15.0723C6.80897 14.9907 6.85406 14.9088 6.89711 14.8268L6.90195 14.8296L7.56861 13.6749L3.66015 12.4448L3.43795 12.8296L1.70591 11.8297L2.7059 10.0976L8.56861 11.9429L9.90195 9.63347C12.6634 4.85055 17.2283 2.31636 20.0981 3.97321C22.9679 5.63007 23.0557 10.8505 20.2943 15.6335L19.2944 17.3656L9.52289 14.29L8.60983 15.8715C6.96632 18.7181 4.08307 20.1303 2.1699 19.0258C0.256728 17.9212 0.0381199 14.7181 1.68162 11.8715ZM10.5229 12.558L18.34 15.0184L18.5622 14.6335L18.5575 14.6307C20.6912 10.716 20.9501 6.77453 19.0981 5.70526C17.2461 4.636 13.9621 6.83093 11.6387 10.6362L11.634 10.6335L10.5229 12.558Z" class="svg-bg"/>
</svg>
`;
/**
 * IconAnnotationsSplineContour is a generated icon component.
 */
let IconAnnotationsSplineContour = IconAnnotationsSplineContour_1 = class IconAnnotationsSplineContour extends IconBaseElement {
    render() {
        return html `${IconAnnotationsSplineContour_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconAnnotationsSplineContour.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconAnnotationsSplineContour = IconAnnotationsSplineContour_1 = __decorate([
    customElement('zui-icon-annotations-spline-contour')
], IconAnnotationsSplineContour);
export { IconAnnotationsSplineContour };
